import {
  MessageItem,
  MessagesBody,
  MessagesInterface,
  MessagesQueryParams,
} from "@/core/reatom/state/messages/types";
import { AxiosResponse } from "axios";
import instance from "../instance";

export const getMessages = async (
  params: MessagesQueryParams
): Promise<MessagesInterface> => {
  try {
    const res: AxiosResponse<MessagesInterface> = await instance.get(
      `/v1/orders/messages`,
      {
        params: {
          ...params,
          temp_url: true,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const sendMessage = async (body: MessagesBody): Promise<MessageItem> => {
  try {
    const res: AxiosResponse<MessageItem> = await instance.post(
      `/v1/orders/messages`,

      body
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
